"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomCommands = void 0;
const useCustomCommands = () => {
    const container = document.getElementById("custom_commands");
    if (!container) {
        return;
    }
    let commands = container.value;
    const prefix = container.dataset.prefix;
    if (!commands) {
        return;
    }
    if (!prefix) {
        return;
    }
    return {
        list: JSON.parse(commands),
        prefix: prefix
    };
};
exports.useCustomCommands = useCustomCommands;
